// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
import BookmarkIcon from "@assets/svg/BookmarkIcon";
import BriefcaseIcon from "@assets/svg/BriefcaseIcon";
import dayjs from "@lib/dayjs";

const applications = [
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
];

const LatestApplications = () => {
  return (
    <div className="flex flex-col min-h-0 w-[55%]">
      <div className="flex items-center justify-between">
        <span className="font-bold text-primary text-sm">
          Latest Applications
        </span>
        <button className="font-semibold text-blue-500 text-xs">
          View Applicants
        </button>
      </div>
      {/* List Section */}
      <div className="mt-5 flex flex-col gap-5 min-h-0 overflow-y-scroll no-scrollbar">
        {applications?.map((application, applicationIndex) => {
          return (
            <div
              key={applicationIndex}
              className="flex items-center justify-between"
            >
              <div className="flex flex-1 items-center gap-3.5">
                <img src={ProfileImg} className="w-11 h-11 rounded-full" />
                <div className="flex flex-col justify-between flex-1 gap-2">
                  <span className="text-xs text-light-black">
                    {dayjs().format("hh:mm a")}, {dayjs().format("dddd DD MMM")}
                  </span>
                  <span className="text-xs font-medium">Kathryn Murphy</span>
                </div>
              </div>
              <div className="flex flex-1 flex-col justify-between gap-2">
                <span className="text-xs text-light-black">JO-123ABC</span>
                <span className="text-xs font-medium">
                  Full Stack Developer
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LatestApplications;
